import React, { useCallback, useRef, useState } from 'react'
import AMSListing from '../../components/listing/AMSListing';
import { useGetAllFieldsQuery, useGetScopesforFieldsQuery } from '../../api/formsApiSlice';
import { ActionType, Column, Field, FieldGroupEnum, ImportTypeEnum } from '../../types/types';
import { useNavigate } from 'react-router-dom';
import ImportModal from './Modals/ImportModal';
import { useDeleteImportMutation, useGetAllAccountsQuery, useGetImportContactQuery } from '../../api/contactApiSlice';
import DeletePrompt from '../../components/DeletePrompt';

const ImportCenter = () => {
  const navigate = useNavigate();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState({
    isOpen: false,
    id: 0,
  });
  const [loading, setLoading] = useState(false);
  const [deleteImport] = useDeleteImportMutation();
  const lastParamsRef = useRef<{
    page: number;
    perPage: number;
    sort?: { field: string; direction: "ASC" | "DESC" };
    query?: string;
    filters: Record<string, any>;
  }>({
    page: 1,
    perPage: 10,
    filters: {},
  });

  const [initialFilters, setInitialFilters] = useState({
    ...lastParamsRef.current,
    query: "",
  });

  const { sort, filters, ...rest } = initialFilters;
  const {
    data: UserDetails
  } = useGetAllAccountsQuery(
    {
      refetchOnMountOrArgChange: true,
    }
  );

  const {
    data: scopes,
    isFetching: isFetchingScopes,
    isError: scopesError
  } = useGetScopesforFieldsQuery({ isVisible: true });


  const staticFormsColumns: Column[] = [
    { id: "originalFileName", label: "Import Name", isSortable: false },
    { id: "fileName", label: "File Name", isSortable: true },
    { id: "userName", label: "Imported By", },
    { id: "importType", label: "Import Type" },
    { id: "scope", label: "Scope" },
    { id: "totalRecords", label: "Total Records" },
    { id: "totalProcessed", label: "Records Processed" },
    { id: "errorCount", label: "Error Counts", isFlag: false },
    { id: "createdAt", label: "Creation Date", isSortable: true },

    // { id: "totalRecords", label: "Records processed", },
    { id: "duplicateCount", label: "Duplicates", isSortable: true },
    { id: "statusId", label: "Status", isFlag: true },

    { id: "createdAt", label: "Date & Time", isSortable: true },

  ];



  const filterGroups = [
    {
      key: 'importType',
      label: 'Import Type',
      dataType: 'select',
      options: Object.values(ImportTypeEnum).map((value) => ({
        value,
        label: value
          .toLowerCase()
          .split('_')
          .map((word) => word[0].toUpperCase() + word.slice(1))
          .join(' '),
      })),
    },
        {
      key: 'createdAt',
      label: 'Creation Date',
      dataType: 'date',
      options: [],
    },
    {
      key: 'createdBy',
      label: 'Imported By',
      dataType: 'select',
      options: UserDetails?.options,
    },
    {
      key: 'scopeId',
      label: 'Scope',
      dataType: 'select',
      options: scopes?.options,
    },
  ];


  const params = {
    ...rest,
    ...filters,
    sort: sort?.field,
    sortDir: sort?.direction,
  };
  const {
    data: AllContacts,
    refetch,
    isLoading,
    isFetching,
  } = useGetImportContactQuery(
    { ...params },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  const handleDelete = async (id: number) => {
    try {
      setLoading(true);
      await deleteImport(id);
      await refetch();
    } catch (error) {
      console.error("Failed to delete:", error);
    } finally {
      setLoading(false);
      setIsDeleteModalOpen({ isOpen: false, id: 0 });
    }
  };


  return (
    <>
      <AMSListing
        showFilters
        // showDateRangeFilter
        routeKey="importsListing"
        noDataTitle="No Import Found"
        noDataSubtitle="Your import list is currently empty. Start adding new imports to keep everything organized and easy to find."
        filterGroups={filterGroups}
        title="Import History"
        subtitle="Import or update contacts and organization using Excel file."
        columns={staticFormsColumns}
        // data={AllFields?.fields?.map((field: Field) => ({
        //   ...field,
        //   fieldScopes: field.isGlobal ? 'Global' : field.fieldScopes?.map(scope => scope.scope?.displayName).filter(Boolean).join(', ')
        // })) || []}
        data={AllContacts?.data || []}
        totalItems={AllContacts?.totalCount}
        loading={isLoading || isFetching}
        skeletonHeight={'42px'}
        onAction={useCallback(
          async (action: ActionType, id: string, state?: string) => {            
            const numericId = Number(id);
            if (action === "view") {
              navigate(`/home/records/${numericId}`, { state: { scope: state } });
              return;
            }
            if (action === "delete") {
              setIsDeleteModalOpen({
                isOpen: true,
                id: numericId
              })
              return;
            }

          },
          [refetch, AllContacts?.data]
        )}
        setInitialFilters={setInitialFilters}
        refetchListing={refetch}
      />

      {isDeleteModalOpen.isOpen && <DeletePrompt
        loading={loading}
        onConfirm={() => handleDelete(isDeleteModalOpen.id)}
        onCancel={() => setIsDeleteModalOpen({ isOpen: false, id: 0 })}
      />}
    </>
  )
}

export default ImportCenter
